var _defs, _rect, _path, _rect2, _text, _text2, _circle, _path2, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "case",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8E8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4338CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screen",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1F2440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bolt",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB020"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 48,
    height: 56,
    rx: 10,
    fill: "url(#case)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10h26",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 36,
    height: 17,
    rx: 4,
    fill: "url(#screen)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 17,
    y: 28,
    fontFamily: "Courier New, monospace",
    fontSize: 11,
    fontWeight: 700,
    fill: "#4ADE80"
  }, "042")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 28,
    textAnchor: "end",
    fontFamily: "Arial, sans-serif",
    fontSize: 5.5,
    fontWeight: 700,
    fill: "#4ADE80"
  }, "kWh")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 46,
    r: 9,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 39.5L28 47h4l-1.5 6 6-8h-4l1.5-5.5z",
    fill: "url(#bolt)",
    stroke: "#E08A00",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 53,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 53,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnits);
export default __webpack_public_path__ + "static/media/units.b8b3d3fe81e6c5aa02b05429405f1969.svg";
export { ForwardRef as ReactComponent };